module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-laughing-fill-b88137db.svg";